import _slicedToArray from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
export var useMotionPreference = function useMotionPreference() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      reduceMotion = _React$useState2[0],
      setReduceMotion = _React$useState2[1];

  React.useEffect(function () {
    var _a, _b;

    var mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
    setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);

    var listener = function listener(event) {
      return setReduceMotion(event.matches);
    };

    (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 ? void 0 : _b.call(mediaQuery, "change", listener);
    return function () {
      var _a;

      return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
    };
  }, []);
  return reduceMotion;
};